const ACTION_TYPES = {
  GET_TICKER_SUCCESS: "GET_TICKER_SUCCESS",
  GET_TICKER_FAILED: "GET_TICKER_FAILED",
  UPDATE_TICKER_SUCCESS: "UPDATE_TICKER_SUCCESS",
  UPDATE_TICKER_FAILED: "UPDATE_TICKER_FAILED"
};

export default ACTION_TYPES;
